<ui5-busy-indicator
  size="Medium"
  class="d-flex"
  active></ui5-busy-indicator>
